// myTRiBE+ discipleship path: SERVE → PRAY → GIVE, plus electives.

export const TRIBE = {
  name:"myTRiBE+",
  sub:"Discipleship & Development",
  intro:"Three phases at your own pace: SERVE, PRAY, and GIVE. Every class builds on the last — from your first Sunday to leading in the room. The journey ends where history happens: in a TRiBE, with people.",
  phases:[
    "SERVE",
    "PRAY",
    "GIVE"
  ],
  path:[
    {
      type:"phase",
      id:"p-serve",
      name:"SERVE",
      note:"You belong here"
    },
    {
      type:"course",
      id:"tt101",
      name:"TribeTrack 101: Welcome to the Tribe",
      lessons:3,
      desc:"Our story. Our mission. Your invitation. This Tribe doesn't just gather people — it launches stories."
    },
    {
      type:"checkpoint",
      id:"ctt101",
      name:"TribeTrack 101 checkpoint"
    },
    {
      type:"course",
      id:"tt102",
      name:"TribeTrack 102: This Is How We Move",
      lessons:4,
      desc:"The culture, the codes, the commitment. You're not attending — you're becoming. Step into the Tribe."
    },
    {
      type:"checkpoint",
      id:"ctt102",
      name:"TribeTrack 102 checkpoint"
    },
    {
      type:"phase",
      id:"p-pray",
      name:"PRAY",
      note:"Pass the TribeTrack 102 checkpoint to enter"
    },
    {
      type:"course",
      id:"201",
      name:"201: Prayer",
      lessons:5,
      desc:"Talking with God like He's actually listening. He is."
    },
    {
      type:"checkpoint",
      id:"c201",
      name:"201 checkpoint"
    },
    {
      type:"course",
      id:"202",
      name:"202: Hearing God",
      lessons:4,
      desc:"His voice, your ears. Learning to recognize it."
    },
    {
      type:"checkpoint",
      id:"c202",
      name:"202 checkpoint"
    },
    {
      type:"course",
      id:"203",
      name:"203: Faith",
      lessons:4,
      desc:"Trust with your feet on it."
    },
    {
      type:"checkpoint",
      id:"c203",
      name:"203 checkpoint"
    },
    {
      type:"course",
      id:"204",
      name:"204: The Word",
      lessons:5,
      desc:"What the Bible is, how to read it, why NLT hits different."
    },
    {
      type:"checkpoint",
      id:"c204",
      name:"204 checkpoint"
    },
    {
      type:"course",
      id:"205",
      name:"205: Worship Is a Lifestyle",
      lessons:3,
      desc:"Not the prelude. The point."
    },
    {
      type:"checkpoint",
      id:"c205",
      name:"205 checkpoint"
    },
    {
      type:"phase",
      id:"p-give",
      name:"GIVE",
      note:"Pass the 205 checkpoint to enter"
    },
    {
      type:"course",
      id:"301",
      name:"301: Generosity",
      lessons:4,
      desc:"Open hands. A generous life starts before the offering."
    },
    {
      type:"checkpoint",
      id:"c301",
      name:"301 checkpoint"
    },
    {
      type:"course",
      id:"302",
      name:"302: The First Ten",
      lessons:3,
      desc:"Trust God with the first ten. Make it a habit."
    },
    {
      type:"checkpoint",
      id:"c302",
      name:"302 checkpoint"
    },
    {
      type:"course",
      id:"303",
      name:"303: Multiply",
      lessons:3,
      desc:"You've been filled. Now pour out. Invite one."
    },
    {
      type:"checkpoint",
      id:"c303",
      name:"303 checkpoint"
    },
    {
      type:"course",
      id:"304",
      name:"304: Lead the Room",
      lessons:5,
      desc:"Leadership at CLLXTV: serve first, carry culture, multiply leaders."
    },
    {
      type:"checkpoint",
      id:"c304",
      name:"304 checkpoint"
    },
    {
      type:"finale",
      id:"finale",
      name:"Join a TRiBE+",
      note:"History happens with people"
    }
  ],
  electives:[
    {
      name:"Defining Character",
      lessons:5,
      desc:"Who you are when nobody's watching."
    },
    {
      name:"Money God's Way",
      lessons:7,
      desc:"Stewardship, budgets, and open hands."
    },
    {
      name:"The Names of God",
      lessons:3,
      desc:"Every name reveals His nature."
    },
    {
      name:"The Beatitudes",
      lessons:2,
      desc:"Jesus' upside-down blueprint."
    },
    {
      name:"Armor of God",
      lessons:8,
      desc:"Ephesians 6, piece by piece."
    },
    {
      name:"Characters of the Bible",
      lessons:12,
      desc:"Real people, real flaws, real faith."
    },
    {
      name:"SHIP Class",
      lessons:0,
      desc:"Relationships, the Ship Happens way. Coming soon.",
      soon:true
    }
  ]
};
